import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

export const SelectMbId = ({ mbIdList, onUserAction, defaultValue }) => {
  return (
    <span style={{ width: "70%" }}>
      <Select
        name="uniqueMbIdList"
        placeholder="--Select MbId--"
        value={defaultValue}
        options={mbIdList.map((mbId) => ({
          label: mbId,
          value: mbId,
        }))}
        onChange={(val) => onUserAction("mbIdSelect", val)}
      />
    </span>
  );
};

SelectMbId.propTypes = {
  mbIdList: PropTypes.array.isRequired,
  onUserAction: PropTypes.func.isRequired,
  defaultValue: PropTypes.object.isRequired,
};
